import { CONTACT } from '../config';
import type { LegalBlock } from './legal-types';

export const legalElBlocks: LegalBlock[] = [
  { type: 'section-title', text: 'ΠΟΛΙΤΙΚΗ ΑΠΟΡΡΗΤΟΥ' },
  { type: 'heading', text: '1. Εισαγωγή' },
  {
    type: 'paragraph',
    text: 'Η παρούσα Πολιτική Απορρήτου περιγράφει τον τρόπο με τον οποίο η εταιρεία «Shmatch Ι.Κ.Ε.» (εφεξής «Shmatch», «Εταιρεία», «εμείς»), συλλέγει, χρησιμοποιεί, αποθηκεύει και προστατεύει τα προσωπικά δεδομένα των χρηστών της εφαρμογής και της ιστοσελίδας της.',
  },
  {
    type: 'paragraph',
    text: 'Η «Shmatch» δεσμεύεται να προστατεύει τα προσωπικά δεδομένα των χρηστών της σύμφωνα με:',
  },
  {
    type: 'list',
    items: [
      'τον Γενικό Κανονισμό Προστασίας Δεδομένων (ΕΕ) 2016/679 («GDPR»),',
      'τον ν. 4624/2019,',
      'την ελληνική και ευρωπαϊκή νομοθεσία περί προστασίας προσωπικών δεδομένων,',
      'και τις σχετικές κατευθυντήριες οδηγίες της Αρχής Προστασίας Δεδομένων Προσωπικού Χαρακτήρα.',
    ],
  },
  { type: 'heading', text: '2. Στοιχεία Υπεύθυνου Επεξεργασίας' },
  { type: 'paragraph', text: 'Επωνυμία:  «Shmatch Ι.Κ.Ε.»' },
  { type: 'paragraph', text: 'Διακριτικός Τίτλος: «Shmatch»' },
  { type: 'paragraph', text: 'Έδρα: Βασιλίσσης Όλγας 24, Μαρούσι Αττικής, Τ.Κ. 15124' },
  { type: 'paragraph', text: 'Αριθμός ΓΕΜΗ: 187928603000' },
  { type: 'paragraph', text: 'ΑΦΜ: 803036434' },
  { type: 'paragraph', text: ` Email επικοινωνίας: ${CONTACT.email}` },
  { type: 'paragraph', text: `Email για ζητήματα προσωπικών δεδομένων: ${CONTACT.privacyEmail}` },
  { type: 'heading', text: '3. Ποια δεδομένα συλλέγουμε' },
  {
    type: 'paragraph',
    text: 'Η «Shmatch» δύναται να συλλέγει τις ακόλουθες κατηγορίες προσωπικών δεδομένων:',
  },
  { type: 'subheading', text: '3.1 Δεδομένα λογαριασμού' },
  {
    type: 'list',
    items: [
      'Ονοματεπώνυμο',
      'Διεύθυνση email',
      'Τηλέφωνο επικοινωνίας',
      'Username',
      'Κωδικός πρόσβασης (κρυπτογραφημένος)',
    ],
  },
  { type: 'subheading', text: '3.2 Δεδομένα κρατήσεων' },
  {
    type: 'list',
    items: [
      'Επιλεγμένες αθλητικές εγκαταστάσεις',
      'Ημερομηνίες και ώρες κράτησης',
      'Ιστορικό κρατήσεων',
      'Στοιχεία πληρωμής',
    ],
  },
  { type: 'subheading', text: '3.3 Τεχνικά δεδομένα' },
  {
    type: 'list',
    items: [
      'IP address',
      'Device identifiers',
      'Browser type',
      'Λειτουργικό σύστημα',
      'Log files',
    ],
  },
  { type: 'subheading', text: '3.4 Δεδομένα χρήσης' },
  {
    type: 'list',
    items: [
      'Αλληλεπίδραση με την εφαρμογή',
      'Προτιμήσεις χρήστη',
      'Cookies και analytics data',
    ],
  },
  { type: 'heading', text: '4. Σκοποί επεξεργασίας' },
  { type: 'paragraph', text: 'Η επεξεργασία των προσωπικών δεδομένων πραγματοποιείται για:' },
  {
    type: 'list',
    items: [
      'δημιουργία και διαχείριση λογαριασμού,',
      'ολοκλήρωση κρατήσεων,',
      'παροχή υπηρεσιών της πλατφόρμας,',
      'υποστήριξη χρηστών,',
      'βελτίωση της εμπειρίας χρήσης,',
      'στατιστική και αναλυτική επεξεργασία,',
      'πρόληψη κακόβουλων ενεργειών,',
      'συμμόρφωση με νομικές υποχρεώσεις,',
      'αποστολή ενημερωτικών επικοινωνιών, όπου παρέχεται συγκατάθεση.',
    ],
  },
  { type: 'heading', text: '5. Νομικές βάσεις επεξεργασίας' },
  { type: 'paragraph', text: 'Η επεξεργασία βασίζεται:' },
  {
    type: 'list',
    items: [
      'στην εκτέλεση σύμβασης,',
      'στη συγκατάθεση του χρήστη,',
      'στο έννομο συμφέρον της Εταιρείας,',
      'σε νομικές υποχρεώσεις.',
    ],
  },
  { type: 'heading', text: '6. Διαβίβαση δεδομένων σε τρίτους' },
  { type: 'paragraph', text: 'Η «Shmatch» δύναται να συνεργάζεται με:' },
  {
    type: 'list',
    items: [
      'παρόχους cloud υπηρεσιών,',
      'παρόχους πληρωμών,',
      'παρόχους analytics,',
      'τεχνικούς συνεργάτες,',
      'αθλητικές εγκαταστάσεις και συνεργαζόμενα venues.',
    ],
  },
  {
    type: 'paragraph',
    text: 'Οι τρίτοι επεξεργάζονται δεδομένα αποκλειστικά για λογαριασμό της Εταιρείας και δεσμεύονται συμβατικά για την προστασία τους.',
  },
  { type: 'heading', text: '7. Διαβιβάσεις εκτός ΕΟΧ' },
  {
    type: 'paragraph',
    text: 'Σε περίπτωση διαβίβασης δεδομένων εκτός Ευρωπαϊκού Οικονομικού Χώρου, η «Shmatch» εφαρμόζει κατάλληλες εγγυήσεις σύμφωνα με τον «GDPR», όπως Standard Contractual Clauses («SCCs»).',
  },
  { type: 'heading', text: '8. Χρόνος διατήρησης' },
  {
    type: 'paragraph',
    text: 'Τα προσωπικά δεδομένα διατηρούνται μόνο για όσο χρονικό διάστημα απαιτείται για:',
  },
  {
    type: 'list',
    items: [
      'την παροχή των υπηρεσιών,',
      'τη συμμόρφωση με νομικές υποχρεώσεις,',
      'την επίλυση διαφορών,',
      'την προστασία των εννόμων συμφερόντων της Εταιρείας.',
    ],
  },
  { type: 'heading', text: '9. Δικαιώματα χρηστών' },
  { type: 'paragraph', text: 'Οι χρήστες έχουν δικαίωμα:' },
  {
    type: 'list',
    items: [
      'πρόσβασης,',
      'διόρθωσης,',
      'διαγραφής,',
      'περιορισμού επεξεργασίας,',
      'φορητότητας,',
      'εναντίωσης,',
      'ανάκλησης συγκατάθεσης.',
    ],
  },
  { type: 'paragraph', text: `Αιτήματα μπορούν να υποβάλλονται στο: ${CONTACT.privacyEmail}` },
  {
    type: 'route-link',
    before: 'Για διαγραφή του λογαριασμού Shmatch και των σχετικών προσωπικών δεδομένων, χρησιμοποιήστε τη ',
    linkText: 'σελίδα αιτήματος διαγραφής λογαριασμού',
    to: '/delete-account',
    after: '.',
  },
  { type: 'heading', text: '10. Ασφάλεια δεδομένων' },
  {
    type: 'paragraph',
    text: 'Η «Shmatch» εφαρμόζει κατάλληλα τεχνικά και οργανωτικά μέτρα ασφαλείας, συμπεριλαμβανομένων:',
  },
  {
    type: 'list',
    items: [
      'encryption,',
      'access controls,',
      'authentication mechanisms,',
      'logging,',
      'περιοδικών ελέγχων ασφαλείας.',
    ],
  },
  { type: 'heading', text: '11. Δεδομένα ανηλίκων' },
  {
    type: 'paragraph',
    text: 'Η πλατφόρμα δεν προορίζεται για χρήση από ανηλίκους χωρίς γονική συναίνεση.',
  },
  { type: 'heading', text: '12. Τροποποιήσεις πολιτικής' },
  {
    type: 'paragraph',
    text: 'Η Εταιρεία δύναται να τροποποιεί την παρούσα Πολιτική οποτεδήποτε. Οι αλλαγές δημοσιεύονται στην εφαρμογή και την ιστοσελίδα.',
  },
  { type: 'section-title', text: 'ΠΟΛΙΤΙΚΗ COOKIES' },
  { type: 'heading', text: '1. Τι είναι τα cookies' },
  {
    type: 'paragraph',
    text: 'Τα cookies είναι μικρά αρχεία δεδομένων που αποθηκεύονται στη συσκευή του χρήστη κατά την περιήγησή του.',
  },
  { type: 'heading', text: '2. Κατηγορίες cookies' },
  { type: 'subheading', text: 'Απαραίτητα cookies' },
  { type: 'paragraph', text: 'Απαιτούνται για τη βασική λειτουργία της εφαρμογής.' },
  { type: 'subheading', text: 'Functional cookies' },
  { type: 'paragraph', text: 'Αποθηκεύουν προτιμήσεις χρήστη.' },
  { type: 'subheading', text: 'Analytics cookies' },
  { type: 'paragraph', text: 'Χρησιμοποιούνται για στατιστική ανάλυση και βελτίωση υπηρεσιών.' },
  { type: 'subheading', text: 'Marketing cookies' },
  {
    type: 'paragraph',
    text: 'Χρησιμοποιούνται για εξατομικευμένες διαφημίσεις και προωθητικές ενέργειες.',
  },
  { type: 'heading', text: '3. Διαχείριση cookies' },
  {
    type: 'paragraph',
    text: 'Οι χρήστες μπορούν να διαχειρίζονται ή να απενεργοποιούν τα cookies μέσω:',
  },
  {
    type: 'list',
    items: [
      'του cookie banner,',
      'των ρυθμίσεων browser,',
      'των ρυθμίσεων της εφαρμογής.',
    ],
  },
  { type: 'heading', text: '4. Third-party cookies' },
  { type: 'paragraph', text: 'Η εφαρμογή μπορεί να χρησιμοποιεί υπηρεσίες τρίτων όπως:' },
  {
    type: 'list',
    items: ['Google Analytics,', 'Firebase,', 'Meta Pixel,', 'payment gateways.'],
  },
  { type: 'section-title', text: 'GDPR DISCLOSURES' },
  { type: 'heading', text: 'Βασικές Πληροφορίες GDPR' },
  {
    type: 'paragraph',
    text: 'Η «Shmatch» ενεργεί ως Υπεύθυνος Επεξεργασίας για τα προσωπικά δεδομένα που συλλέγονται μέσω της πλατφόρμας.',
  },
  { type: 'paragraph', text: 'Η επεξεργασία πραγματοποιείται σύμφωνα με τις αρχές:' },
  {
    type: 'list',
    items: [
      'νομιμότητας,',
      'διαφάνειας,',
      'ελαχιστοποίησης δεδομένων,',
      'ακρίβειας,',
      'περιορισμού σκοπού,',
      'ακεραιότητας και εμπιστευτικότητας.',
    ],
  },
  {
    type: 'paragraph',
    text: 'Η «Shmatch» εφαρμόζει privacy by design και privacy by default κατά τον σχεδιασμό και λειτουργία της πλατφόρμας.',
  },
  {
    type: 'paragraph',
    text: 'Σε περίπτωση παραβίασης προσωπικών δεδομένων, η Εταιρεία θα ενεργεί σύμφωνα με τα προβλεπόμενα από τον «GDPR» και την ισχύουσα νομοθεσία.',
  },
  { type: 'section-title', text: 'TERMS & CONDITIONS' },
  { type: 'heading', text: '1. Εισαγωγή' },
  {
    type: 'paragraph',
    text: 'Οι παρόντες Όροι Χρήσης διέπουν τη χρήση της εφαρμογής και της ιστοσελίδας της «Shmatch».',
  },
  {
    type: 'paragraph',
    text: 'Με τη χρήση της πλατφόρμας, ο χρήστης αποδέχεται πλήρως τους παρόντες όρους.',
  },
  { type: 'heading', text: '2. Περιγραφή υπηρεσίας' },
  {
    type: 'paragraph',
    text: 'Η «Shmatch» παρέχει ψηφιακή πλατφόρμα αναζήτησης, σύγκρισης και κράτησης αθλητικών εγκαταστάσεων.',
  },
  {
    type: 'paragraph',
    text: 'Η «Shmatch» λειτουργεί ως τεχνολογική πλατφόρμα διασύνδεσης χρηστών και συνεργαζόμενων αθλητικών εγκαταστάσεων.',
  },
  { type: 'heading', text: '3. Δημιουργία λογαριασμού' },
  { type: 'paragraph', text: 'Για τη χρήση ορισμένων υπηρεσιών απαιτείται δημιουργία λογαριασμού.' },
  { type: 'paragraph', text: 'Ο χρήστης υποχρεούται:' },
  {
    type: 'list',
    items: [
      'να παρέχει αληθή στοιχεία,',
      'να διατηρεί εμπιστευτικά τα credentials του,',
      'να ενημερώνει για μη εξουσιοδοτημένη χρήση.',
    ],
  },
  { type: 'paragraph', text: 'Η «Shmatch» διατηρεί το δικαίωμα αναστολής ή διαγραφής λογαριασμού.' },
  { type: 'heading', text: '4. Υποχρεώσεις χρηστών' },
  { type: 'paragraph', text: 'Οι χρήστες υποχρεούνται:' },
  {
    type: 'list',
    items: [
      'να χρησιμοποιούν νόμιμα την πλατφόρμα,',
      'να μην παραβιάζουν δικαιώματα τρίτων,',
      'να μην παρεμβαίνουν στη λειτουργία της εφαρμογής,',
      'να μην επιχειρούν μη εξουσιοδοτημένη πρόσβαση,',
      'να μην χρησιμοποιούν αυτοματοποιημένα συστήματα scraping,',
      'να μην μεταδίδουν κακόβουλο λογισμικό.',
    ],
  },
  { type: 'heading', text: '5. Απαγορευμένες χρήσεις' },
  { type: 'paragraph', text: 'Απαγορεύεται:' },
  {
    type: 'list',
    items: [
      'η χρήση της πλατφόρμας για παράνομους σκοπούς,',
      'η δημοσίευση προσβλητικού ή παράνομου περιεχομένου,',
      'η παραβίαση προσωπικών δεδομένων τρίτων,',
      'η παραπλανητική χρήση,',
      'η εμπορική εκμετάλλευση χωρίς άδεια,',
      'η αντιγραφή ή αναπαραγωγή του λογισμικού.',
    ],
  },
  { type: 'heading', text: '6. Κρατήσεις και πληρωμές' },
  { type: 'paragraph', text: 'Οι κρατήσεις πραγματοποιούνται μέσω της εφαρμογής και υπόκεινται:' },
  {
    type: 'list',
    items: [
      'στη διαθεσιμότητα των εγκαταστάσεων,',
      'στις πολιτικές ακύρωσης,',
      'στους όρους των συνεργαζόμενων venues.',
    ],
  },
  { type: 'paragraph', text: 'Η «Shmatch» δεν φέρει ευθύνη για:' },
  {
    type: 'list',
    items: [
      'αλλαγές διαθεσιμότητας,',
      'ακυρώσεις από τρίτους παρόχους,',
      'ποιότητα εγκαταστάσεων,',
      'ατυχήματα κατά τη χρήση εγκαταστάσεων.',
    ],
  },
  { type: 'heading', text: '7. Περιορισμός ευθύνης' },
  {
    type: 'paragraph',
    text: 'Η «Shmatch» καταβάλλει εύλογες προσπάθειες για την ορθή λειτουργία της πλατφόρμας, χωρίς να εγγυάται:',
  },
  {
    type: 'list',
    items: [
      'αδιάλειπτη λειτουργία,',
      'απουσία τεχνικών σφαλμάτων,',
      'διαθεσιμότητα υπηρεσιών,',
      'ακρίβεια πληροφοριών τρίτων.',
    ],
  },
  { type: 'paragraph', text: 'Η χρήση της πλατφόρμας γίνεται με αποκλειστική ευθύνη του χρήστη.' },
  {
    type: 'paragraph',
    text: 'Στο μέγιστο βαθμό που επιτρέπεται από τη νομοθεσία, η «Shmatch» δεν ευθύνεται για:',
  },
  {
    type: 'list',
    items: [
      'έμμεσες ή αποθετικές ζημίες,',
      'απώλεια δεδομένων,',
      'διαφυγόντα κέρδη,',
      'διακοπή λειτουργίας,',
      'πράξεις ή παραλείψεις τρίτων συνεργατών.',
    ],
  },
  { type: 'heading', text: '8. Πνευματική ιδιοκτησία (IP Clauses)' },
  { type: 'paragraph', text: 'Όλο το περιεχόμενο της πλατφόρμας, συμπεριλαμβανομένων:' },
  {
    type: 'list',
    items: [
      'λογισμικού,',
      'design,',
      'λογοτύπων,',
      'εμπορικών σημάτων,',
      'κειμένων,',
      'γραφικών,',
      'interfaces,',
    ],
  },
  {
    type: 'paragraph',
    text: 'αποτελεί πνευματική και βιομηχανική ιδιοκτησία της «Shmatch» ή νόμιμων δικαιούχων.',
  },
  { type: 'paragraph', text: 'Απαγορεύεται:' },
  {
    type: 'list',
    items: [
      'η αντιγραφή,',
      'η αναπαραγωγή,',
      'η διανομή,',
      'η τροποποίηση,',
      'η reverse engineering χρήση,',
    ],
  },
  { type: 'paragraph', text: 'χωρίς προηγούμενη έγγραφη άδεια.' },
  { type: 'heading', text: '9. Αναστολή ή τερματισμός λογαριασμού' },
  {
    type: 'paragraph',
    text: 'Η «Shmatch» δύναται να αναστείλει ή να διαγράψει λογαριασμό χρήστη σε περίπτωση:',
  },
  {
    type: 'list',
    items: [
      'παραβίασης των όρων,',
      'παράνομης δραστηριότητας,',
      'κατάχρησης της πλατφόρμας,',
      'παραβίασης ασφάλειας.',
    ],
  },
  { type: 'heading', text: '10. Third-party services' },
  {
    type: 'paragraph',
    text: 'Η πλατφόρμα μπορεί να περιλαμβάνει υπηρεσίες τρίτων ή συνδέσμους προς εξωτερικούς παρόχους.',
  },
  {
    type: 'paragraph',
    text: 'Η «Shmatch» δεν ευθύνεται για το περιεχόμενο ή τις πρακτικές των τρίτων αυτών υπηρεσιών.',
  },
  { type: 'heading', text: '11. Τροποποίηση υπηρεσιών και όρων' },
  { type: 'paragraph', text: 'Η «Shmatch» διατηρεί το δικαίωμα:' },
  {
    type: 'list',
    items: [
      'τροποποίησης της πλατφόρμας,',
      'διακοπής λειτουργιών,',
      'αλλαγής των παρόντων όρων,',
    ],
  },
  { type: 'paragraph', text: 'οποτεδήποτε και χωρίς προηγούμενη ειδοποίηση.' },
  { type: 'heading', text: '12. Εφαρμοστέο δίκαιο και δικαιοδοσία' },
  { type: 'paragraph', text: 'Οι παρόντες όροι διέπονται από το ελληνικό και ευρωπαϊκό δίκαιο.' },
  { type: 'paragraph', text: 'Αρμόδια για την επίλυση κάθε διαφοράς ορίζονται τα Δικαστήρια Αθηνών.' },
];
